import { BreadcrumbsItem, LayoutContext } from "@/contexts/layout/layout.context";
import { PropsWithChildren, useState } from "react";

/**
 * LayoutContextProvider component.
 * @description LayoutContext is used to manage shared state related to the layout of the application.
 * It provides a context for managing the header class name and breadcrumbs.
 */
export default function LayoutContextProvider({ children }: PropsWithChildren): React.ReactElement {
  const [headerClassName, setHeaderClassName] = useState<string | undefined>();
  const [headerBreadcrumbs, setHeaderBreadcrumbs] = useState<BreadcrumbsItem[] | undefined>();
  const [mainClassName, setMainClassName] = useState<string | undefined>();

  return (
    <LayoutContext.Provider
      value={{
        headerClassName,
        setHeaderClassName,
        headerBreadcrumbs,
        setHeaderBreadcrumbs,
        mainClassName,
        setMainClassName,
      }}
    >
      {children}
    </LayoutContext.Provider>
  );
}
